<template>
  <div>
    <div class="containerlogin" id="containerlogin">
      <div class="columns">
        <div class="column is-12 ">
          <h3 class="title-login">Iniciar sesión</h3>
          <div class="text-header">
            <p>Se requiere iniciar sesión para que pueda ver, administrar y eliminar sus zonas de interés.</p>
          </div>

          <template>
            <div class="container_redes_sociales">
              <!-- google button -->
              <div class='g-sign-in-button' @click="signInWithGoogle">
                <div class=content-wrapper>
                  <img class='logo-wrapper' src='https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg'>
                  <span class='text-container' @click="signInWithGoogle">Google</span>
                </div>
              </div>

              <!-- facebook button -->
              <div class='g-sign-in-button' @click="signInWithfacebook">
                <div class="content-wrapper btn-facebook">
                  <img class='logo-wrapper logo-wrapper-facebook'
                       src='https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg'>
                  <span class='text-container' @click="signInWithfacebook">Facebook</span>
                </div>
              </div>
            </div>
          </template>

          <div v-if="!showResetPassword">
            <form action="#" @submit.prevent="signInWithEmail(email, password)">
              <!-- email and password -->
              <div class="field">
                <label class="label">Correo</label>
                <div class="control">
                  <input class="input" type="email" placeholder="tu@correo.com" v-model="email">
                </div>
              </div>
              <div class="field">
                <label class="label">Contraseña</label>
                <div class="control">
                  <input class="input" type="password" placeholder="*********" v-model="password">
                </div>
              </div>
            </form>

            <!-- register user -->
            <div class="field is-grouped is-grouped-centered">
              <a @click="registerUserForm()" class="enlaceregistro" href="#"> ¿Éres nuevo por aqui? Crear Una
                cuenta </a>
            </div>

            <!-- reset password -->
            <div class="field is-grouped is-grouped-centered">
              <a @click="resetPasswordForm()" class="enlaceregistro" href="#"> ¿Olvidó la contraseña? </a>
            </div>

            <div class="field is-grouped is-grouped-centered">
              <button @click="signInWithEmail(email, password)" type="submit" class="button is-primary">Ingresar</button>
            </div>

          </div>

          <!-- reset password form -->
          <div class="field" v-if="showResetPassword">
            <span class="label-recuperar mt-6">Para recuperar la contraseña debe ingresar su correo electroníco y seguir las instruciones que le lleguen.</span>
            <div class="field is-grouped is-grouped-left mt-4">
              <div class="field" style="width: 100%">
                <form action="#" @submit.prevent="sendPasswordResetEmail(email)">
                  <label class="label mt-4">Correo</label>
                  <div class="control">
                    <input class="input" type="email" placeholder="tu@correo.com" v-model="email">
                  </div>
                  <div class="btn-recuperacion is-grouped-right mt-4">
                    <button type="submit" class="button is-primary btn-recuperacion-botn">Recuperar contraseña</button>
                  </div>
                </form>
                <div class="is-grouped is-grouped-centered mt-4">
                  <a @click="loginForm()" class="enlacetienecuenta" href="#"> ¿Tienes cuenta? Iniciar sesion. </a>
                </div>
              </div>
            </div>
          </div>

          <div class="notification is-danger mt-6" v-if="error"> {{ error }}</div>
          <div class="notification is-success mt-6" v-if="success"> {{ success }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase';
import axios from "axios";
import {config} from '@/config.json';
import * as LocalStorage from "@/helpers/localstorage";
import * as Utils from "@/helpers/utils";

export default {
  data() {
    return {
      email: '',
      password: '',
      error: '',
      success: '',
      showResetPassword: false,
    }
  },
  name: "Login",
  methods: {
    signInWithEmail(email, password) {
      let self = this;
      this.success = '';
      this.error = '';
      if (!email || !password) {
        this.error = 'Correo o contraseña invalida';
        return;
      }

      this.$root.$emit("app-show-loading", true);
      firebase
          .auth()
          .signInWithEmailAndPassword(email, password)
          .then((result) => {
            self.getUser(result.user);
          })
          .catch((err) => {
            console.log(err);
            self.error = err;
            self.$root.$emit("app-show-loading", false);
          });
    },
    signInWithGoogle: function () {
      let self = this;
      this.success = '';
      this.error = '';
      let provider = new firebase.auth.GoogleAuthProvider();

      this.$root.$emit("app-show-loading", true);
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) => {
            self.getUser(result.user);
          })
          .catch((err) => {
            console.log(err);
            self.error = err;
            self.$root.$emit("app-show-loading", false);
          })
    },
    signInWithfacebook: function () {
      let self = this;
      this.success = '';
      this.error = '';
      let provider = new firebase.auth.FacebookAuthProvider();

      this.$root.$emit("app-show-loading", true);
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) => {
            self.getUser(result.user);
          })
          .catch(err => {
            console.log(err)
            self.error = err;
            self.$root.$emit("app-show-loading", false);
          })
    },
    sendPasswordResetEmail(email) {
      let self = this;
      this.success = '';
      this.error = '';
      if (!email) {
        this.error = "Correo invalido.";
        return;
      }

      this.$root.$emit("app-show-loading", true);
      firebase
          .auth()
          .sendPasswordResetEmail(this.email)
          .then(() => {
            self.email = ""
            self.success = "Correo de recuperación enviado a su cuenta";
          })
          .catch((err) => {
            console.log("Login: ", err)
            self.error = err.error;
          }).finally(() => {
        self.$root.$emit("app-show-loading", false);
      });
    },
    resetPasswordForm() {
      this.showResetPassword = true;
    },
    loginForm() {
      this.showResetPassword = false;
    },
    registerUserForm() {
      this.$root.$emit("navresponsive-show-register", {});
    },
    getUser: function (userFirebase) {
      let self = this;
      this.success = '';
      this.error = '';
      self.$root.$emit("app-show-loading", true);

      axios
          .get(`${config.api.baseURL}/obtenerUsuario/${userFirebase.uid}/0`)
          .then((response) => {
            switch (response.data.descripcion) {
              case "OK": {
                let data = Utils.fromJSON(response.data.jsonCompleto);
                LocalStorage.setUserUID(userFirebase.uid);
                LocalStorage.setUserId(data.id);
                LocalStorage.setMail(userFirebase.email);
                self.$root.$emit("navresponsive-show-interest-site", {});
                self.$root.$emit("navresponsive-show-mapping-list", {});
                return;
              }
              case "NO EXISTE": {
                self.registerUserInServer();
              }
              default: {
                console.log("Login: ", response.data.error);
              }
            }
          })
          .catch((err) => {
            console.log("Login: ", err);
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
          });
    },
    registerUserInServer: function () {
      let self = this;
      this.success = '';
      this.error = '';

      let userFirebase = firebase.auth().currentUser;
      let user = {
        "id": 0,
        "nombre": userFirebase.displayName,
        "correo": userFirebase.email,
        "uid": userFirebase.uid,
        "genero": "Masculino",
        "apellido": "",
        "id_perfil": 1,
        "valido": 1,
        "fecha_nacimiento": fecha_nacimiento,
        "fecha_registro": fecha_registro,
        "token": ""
      };

      self.$root.$emit("app-show-loading", true);
      axios({
        method: 'post',
        url: `${config.api.baseURL}/guardarUsuario`,
        data: Utils.toJSON(user),
        headers: {'Content-Type': 'application/json;charset=UTF-8'}
      })
          .then((response) => {
            if (response.data.descripcion != "OK") {
              userFirebase.delete()
            } else {
              let data = Utils.fromJSON(response.data.jsonCompleto);
              LocalStorage.setUserUID(userFirebase.uid);
              LocalStorage.setUserId(data.id);
              LocalStorage.setMail(userFirebase.email);
              self.$root.$emit("navresponsive-show-interest-site", {});
              self.$root.$emit("navresponsive-show-mapping-list", {});
            }
          })
          .catch((err) => {
            console.log('Login: ', err);
          })
          .finally(() => {
            self.$root.$emit("app-show-loading", false);
          });
    },
  }
}
</script>
<style scoped lang="scss">
.logo-wrapper-facebook {
  background: #3b5998 !important;
}

.btn-facebook {
  background: #3b5998;
  color: #FFFFFF;
}

.container_redes_sociales {
  margin: 0 auto;
  text-align: center;
}

.g-sign-in-button {
  margin: 10px;
  display: inline-block;
  width: 200px;
  height: 40px;
  color: #34495e;
  border-radius: 1px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
  transition: background-color .218s, border-color .218s, box-shadow .218s;
}

.g-sign-in-button:hover {
  cursor: pointer;
}

.g-sign-in-button:active {
  transition: background-color 0.2s;
}

.g-sign-in-button .content-wrapper {
  height: 100%;
  width: 100%;
  border: 1px solid transparent;
}

.g-sign-in-button img {
  width: 18px;
  height: 18px;
}

.g-sign-in-button .logo-wrapper {
  padding: 6px;
  background: #fff;
  width: 48px;
  height: 100%;
  border-radius: 1px;
  display: inline-block;
  margin-left: 0px;
}

.g-sign-in-button .text-container {
  font-family: Roboto, arial, sans-serif;
  font-weight: 500;
  letter-spacing: .21px;
  font-size: 16px;
  line-height: 40px;
  vertical-align: top;
  border: none;
  display: inline-block;
  text-align: center;
  width: 110px;
}

.is-success {
  font-size: 0.80rem;
}

.is-danger {
  font-size: 0.80rem;
}

#titulodatauser {
  text-align: center;
}

.label-recuperar {
  margin: 0.625rem 0;
  line-height: 0.5;
  font-size: 0.85rem;
  color: #555;
  text-align: justify;
}

.btn-recuperacion-botn {
  font-size: 0.80rem;
}

.btn-recuperacion {
  margin-top: 5px;
  text-align: right;
}

.enlaceregistro {
  text-align: center;
  padding: 5px;
  color: #555;
  font-size: 0.75rem;
  font-weight: normal;
  text-decoration: underline;
}

.enlacetienecuenta {
  margin-top: 5px;
  text-align: center;
  padding: 5px;
  color: #555;
  font-size: 0.75rem;
  font-weight: normal;
  text-decoration: underline;
}

.containerlogin {
  color: black;
  z-index: 5;
  position: absolute;
  padding: 25px;
  max-width: 300px;
}

.button.is-primary {
  background-color: #23841f !important;
  border-color: transparent;
  color: #fff;
}

.button.is-primary:hover, .button.is-primary.is-hovered {
  background-color: #23841f !important;
  border-color: transparent;
  color: #fff;
}

.text-header {
  color: #555;
}

.text-header p {
  margin: 0.625rem 0;
  line-height: 1.7;
  font-size: 0.875rem;
  color: #555;
}
</style>